import { twMerge } from 'tailwind-merge';

type PopoverProps = {
  title: React.ReactNode;
  children: React.ReactNode;
  containerClassName?: string;
  titleClassName?: string;
  contentClassName?: string;
};

export const Popover = ({
  title,
  children,
  containerClassName,
  titleClassName,
  contentClassName,
}: PopoverProps) => {
  return (
    <div
      className={twMerge('dropdown', containerClassName)}
      data-dropdown="true"
      data-dropdown-placement="bottom"
      data-dropdown-trigger="click"
    >
      <div
        className={twMerge(
          'dropdown-toggle select-none [-webkit-touch-callout:none] [-webkit-user-select:none] hover:cursor-pointer',
          titleClassName,
        )}
      >
        {title}
      </div>
      <div
        className={twMerge(
          'dropdown-content menu-default w-full max-w-[220px]',
          contentClassName,
        )}
      >
        {children}
      </div>
    </div>
  );
};
